import styled from 'styled-components';
import { Badge } from './utils/locationBadgeHelpers';

export const LocationBadges = ({ badges }: { badges: Badge[] }) => {
    if (badges.length === 0) {
        return null;
    }

    return (
        <BadgesContainer>
            {badges.map((badge, index) => (
                <BadgeItem key={index} title={badge.tooltip} $color={badge.color}>
                    {badge.icon}
                </BadgeItem>
            ))}
        </BadgesContainer>
    );
};

const BadgesContainer = styled.div`
    display: flex;
    gap: 4px;
    align-items: center;
    flex-wrap: wrap;
`;

const BadgeItem = styled.span<{ $color?: string }>`
    font-size: 16px;
    line-height: 1;
    filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));

    &:hover {
        transform: scale(1.1);
        transition: transform 0.2s ease;
    }
`;
